module.exports = __webpack_public_path__ + "img/peabodyhall-v-474x632.412d5f0d.jpg";